import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { EMAIL } from "@/lib/site";

export default function PrivacyModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("open-privacy", handler);
    return () => window.removeEventListener("open-privacy", handler);
  }, []);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="privacy-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[70] flex items-end justify-center bg-[#0C0A08]/85 backdrop-blur-sm sm:items-center"
          onClick={() => setOpen(false)}
        >
          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 40, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[85vh] w-full max-w-2xl overflow-y-auto border border-[#383029] bg-[#16110E] p-7 sm:p-10"
          >
            <div className="flex items-start justify-between gap-4">
              <h2 className="font-heading text-xl font-black uppercase tracking-tight text-[#FAF7F2] sm:text-2xl">
                Informativa privacy
              </h2>
              <button
                data-testid="privacy-modal-close"
                onClick={() => setOpen(false)}
                aria-label="Chiudi informativa privacy"
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#383029] text-[#A89F91] transition-colors duration-300 hover:border-[#E05A2C] hover:text-[#FAF7F2]"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="mt-6 space-y-5 text-sm font-light leading-relaxed text-[#C4BBB0]">
              <p>
                <span className="font-medium text-[#FAF7F2]">Titolare del trattamento.</span> YU YieldUp di Luciano — ragione sociale e P.IVA in fase di registrazione — contattabile all'indirizzo <a href={`mailto:${EMAIL}`} className="underline decoration-[#383029] underline-offset-2 hover:text-[#E05A2C]">{EMAIL}</a>.
              </p>
              <p>
                <span className="font-medium text-[#FAF7F2]">Dati raccolti.</span> Quando compili un modulo di questo sito raccogliamo solo quello che scrivi tu: il link del tuo annuncio, il tuo numero WhatsApp e, nei moduli di contatto, nome, email, telefono e messaggio.
              </p>
              <p>
                <span className="font-medium text-[#FAF7F2]">Perché li usiamo.</span> Unicamente per rispondere alla tua richiesta: inviarti la valutazione dell'annuncio o ricontattarti per la chiamata che hai chiesto. Niente newsletter non richieste, niente cessione a terzi, mai.
              </p>
              <p>
                <span className="font-medium text-[#FAF7F2]">Base giuridica e conservazione.</span> Il trattamento si basa sul tuo consenso (art. 6, comma 1, lett. a GDPR). I dati vengono conservati al massimo 12 mesi dalla richiesta, poi eliminati.
              </p>
              <p>
                <span className="font-medium text-[#FAF7F2]">I tuoi diritti.</span> Puoi chiedere in qualsiasi momento accesso, rettifica o cancellazione dei tuoi dati scrivendo a <a href={`mailto:${EMAIL}`} className="underline decoration-[#383029] underline-offset-2 hover:text-[#E05A2C]">{EMAIL}</a>. Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali.
              </p>
              <p>
                <span className="font-medium text-[#FAF7F2]">Cookie.</span> Questo sito non usa cookie di profilazione né di terze parti: solo strumenti tecnici necessari al funzionamento (per esempio ricordare di averti già mostrato l'introduzione).
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
